import { isObject } from '../utils/checks'

export const sortTerms = (a = { totalCount: 0 }, b = { totalCount: 0 }) =>
  b.totalCount - a.totalCount

export const UNITED_STATES_FACET_WHITE_LIST = [
  'what_we_treat',
  'accepted_insurance'
]

export const FACET_WHITE_LIST = [
  'what_we_treat',
  'who_we_treat',
  'treatment_method',
  'treatment_therapies',
  'activities',
  'amenities',
  'setting',
  'aftercare',
  'treatment_services',
  'accepted_insurance'
]

export const getAllowedLocationFacets = (locations) =>
  locations.includes('United States')
    ? UNITED_STATES_FACET_WHITE_LIST
    : FACET_WHITE_LIST

export const isGlobal = (term) => isObject(term) && !!term.global

export const getTermQuickLinks = (term) => {
  return term?.quick_links || []
}

export const isTermEatingDisorders = (term) => {
  return term?.slug === 'eating-disorders'
}

export const isTermSoberLiving = (term) => {
  return term?.slug === 'sober-living'
}
